.track {
  position: relative;
  display: block;
  width: 100%;
  height: var(--space-2);
  border-radius: var(--radius-full);
  background: var(--surface-sunken);
}

.bar {
  display: block;
  height: 100%;
  border-radius: var(--radius-full);
  background: var(--chart-1);
  transition: width var(--duration-base) var(--ease-out);
}

/* Colour reinforces; the figure beside it is what actually says "over". */
.over {
  background: var(--intent-danger);
}

/* The target, as a rule line rather than a second competing colour. */
.rule {
  position: absolute;
  top: calc(var(--space-1) * -0.5);
  bottom: calc(var(--space-1) * -0.5);
  width: 2px;
  border-radius: var(--radius-full);
  background: var(--text-secondary);
}

@media (prefers-reduced-motion: reduce) {
  .bar {
    transition: none;
  }
}
